export function enforceWholeNumber(value: string) {
  // replace the letter `e` and all non-digits
  return value.replace(/e|([^\d])/g, '');
}
